import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

interface AuthState {
  // JWT
  accessToken: string
  // Auth0 の Organization Name
  organizationName: string
  // Auth0 の Organization Display Name
  organizationDisplayName: string
}

type SetOrganizationPayload = {
  name: string
  displayName: string
}

const initialState: AuthState = {} as AuthState

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload
    },
    clearAccessToken: (state) => {
      state.accessToken = null
    },
    setOrganization: (state, action: PayloadAction<SetOrganizationPayload>) => {
      const { name, displayName } = action.payload
      state.organizationName = name
      state.organizationDisplayName = displayName
    },
    clearOrganization: (state) => {
      state.organizationName = null
      state.organizationDisplayName = null
    },
  },
})

export const {
  setAccessToken,
  clearAccessToken,
  setOrganization,
  clearOrganization,
} = authSlice.actions
export const selectAccessToken = (state: RootState) => state.auth.accessToken
export const selectOrganizationName = (state: RootState) =>
  state.auth.organizationName
export const selectOrganizationDisplayName = (state: RootState) =>
  state.auth.organizationDisplayName
export default authSlice.reducer
